import axios from 'axios';
import config from '../config/api';

const API_URL = config.endpoints.tiposSocia;

export const getTiposSocia = (page = null, pageSize = null) => {
	let url = API_URL + '/';
	const params = [];
	if (page) params.push(`page=${page}`);
	if (pageSize) params.push(`pageSize=${pageSize}`);
	if (params.length) url += `?${params.join('&')}`;
	return axios.get(url);
};
export const createTipoSocia = (data) => {
	const payload = {
		TIPOSOCIA_NOMBRE: data.nombre,
		TIPOSOCIA_OBSERVACION: data.observacion
	};
	return axios.post(API_URL + '/crear', payload);
};

export const updateTipoSocia = (id, data) => {
	const payload = {
		TIPOSOCIA_NOMBRE: data.nombre,
		TIPOSOCIA_OBSERVACION: data.observacion
	};
	return axios.put(`${API_URL}/actualizar/${id}`, payload);
};
export const deleteTipoSocia = (id) => axios.delete(`${API_URL}/eliminar/${id}`);
